import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {Title} from "@angular/platform-browser";
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslateModule]
})
export class PageNotFoundComponent {
  private title = inject(Title);

  constructor() {
    this.title.setTitle('Page not found (404)');
  }

}
